import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '../../api/admin.api';
import type {
  AdminNotificationListItemDto,
  AdminNotificationResponseDto,
} from '../../types';

export function useAdminNotifications(options?: { enabled?: boolean }) {
  return useQuery<AdminNotificationListItemDto[]>({
    queryKey: ['admin', 'notifications'],
    queryFn: async () => {
      const { data } = await adminApi.get('/v1/admin/notifications', { params: { limit: 100 } });
      if (Array.isArray(data)) return data;
      if (Array.isArray(data?.items)) return data.items;
      if (Array.isArray(data?.data?.items)) return data.data.items;
      if (Array.isArray(data?.data)) return data.data;
      return [];
    },
    enabled: options?.enabled ?? true,
    staleTime: 30_000,
  });
}


export function useAdminMarkNotificationRead() {
  const queryClient = useQueryClient();
  return useMutation<AdminNotificationResponseDto, Error, string>({
    mutationFn: async (id: string) => {
      const { data } = await adminApi.patch(`/v1/admin/notifications/${id}/read`);
      return data.data || data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'notifications'] });
    },
  });
}
